export const MODAL_OVERLAY = 'MODAL_OVERLAY';
export const MODAL_DIALOG_CONTENT = 'MODAL_DIALOG_CONTENT';
export const ALERT_MODAL_OVERLAY = 'ALERT_MODAL_OVERLAY';
export const ALERT_MODAL_DIALOG_CONTENT = 'ALERT_MODAL_DIALOG_CONTENT';
export const X_BUTTON = 'X_BUTTON';
